// src/app/services/translation.service.ts
import { Injectable } from '@angular/core';
import { Repository } from './repository';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private translationCache = new Map<string, string>();
  private activeLanguage = new BehaviorSubject<string>(null);
  private translationsLoaded = false;
  ngon_ngu: any;
  constructor(public repo: Repository) {
    // Load the current language from localStorage
    this.activeLanguage.next(JSON.parse(localStorage.getItem('ngon_ngu')) || '1');

    this.ngon_ngu = JSON.parse(localStorage.getItem('ngon_ngu'));
    if (this.ngon_ngu == null)
      this.ngon_ngu = "1";
    // Preload translations when service initializes
    this.loadTranslations(this.ngon_ngu);

   

  }

  /**
   * Get active language as an observable
   */
  getActiveLanguage(): Observable<string> {
    return this.activeLanguage.asObservable();
  }

  /**
   * Change the active language
   */
  setLanguage(languageId: any): void {
    localStorage.setItem('ngon_ngu', JSON.stringify(languageId));
    this.activeLanguage.next(languageId);
    this.ngon_ngu = languageId;
    // Clear cache and reload translations when language changes
    this.translationCache.clear();
    this.loadTranslations(languageId);
  }

  /**
   * Translate a text using cache first
   */
  translate(text: string): string {
    if (this.ngon_ngu == "1")
      return text;

    if (!text) return text;

    // If we're in default language (Vietnamese), just return the text
    if (this.activeLanguage.value === '1') {
      return text;
    }

    // Check cache first
    if (this.translationCache.has(text.toLowerCase())) {
      return this.translationCache.get(text.toLowerCase());
    }

    // If translations aren't loaded yet, return the original text
    // and queue this text for translation
    if (!this.translationsLoaded) {
      this.queueForTranslation(text);
      return text;
    }

    // Fall back to repository method for individual translation
    // This should happen rarely after initial load
    this.translateSingle(text);
    return text;
  }

  /**
   * Load all translations from localStorage or API
   */
  private loadTranslations(ngonngu: any): void {
    this.translationsLoaded = false;
    this.ngon_ngu = ngonngu;
    const dataNN = JSON.parse(localStorage.getItem('NgonNgus'));

    if (dataNN && dataNN.length > 0) {
      // Add all translations to cache
      dataNN.forEach(item => {
        if (item.Ten && item.GiaTri) {
          if (!this.translationCache.has(item.Ten.toLowerCase())) 
          this.translationCache.set(item.Ten.toLowerCase(), item.GiaTri);
        }
      });
      this.translationsLoaded = true;
    } else {
      // Load translations from API if not in localStorage
      //this.repo.getRequest('api/login/getdsngongu/', {
      //  ngonnguid: this.ngon_ngu
      //}).subscribe(response => {
      //  if (response && response.length > 0) {
      //    localStorage.setItem('NgonNgus', JSON.stringify(response));
      //    response.forEach(item => {
      //      if (item.Ten && item.GiaTri) {
      //        if (!this.translationCache.has(item.Ten.toLowerCase())) 
      //        this.translationCache.set(item.Ten.toLowerCase(), item.GiaTri);
      //      }
      //    });
      //  }
      //  this.translationsLoaded = true;
      //});


    }
  }

  /**
   * Queue text for translation when bulk loading
   */
  private pendingTranslations: Set<string> = new Set();
  private queueForTranslation(text: string): void {
    if (!this.pendingTranslations.has(text)) {
      this.pendingTranslations.add(text);

      // Use setTimeout to batch translations in next event loop
      setTimeout(() => {
        this.processPendingTranslations();
      }, 100);
    }
  }

  /**
   * Process all pending translations in a batch
   */
  private processPendingTranslations(): void {
    if (this.pendingTranslations.size === 0) return;

    const textsToTranslate = Array.from(this.pendingTranslations);
    this.pendingTranslations.clear();

    // Make a batch request to translate multiple strings at once
    this.repo.postRequest('api/donvi/batch_translate', {
      Id: this.activeLanguage.value,
      Ten: textsToTranslate
    }).subscribe(response => {
      if (response && response.translations) {
        response.translations.forEach(item => {
          this.translationCache.set(item.original.toLowerCase(), item.translated);
        });
      }
    });
  }

  /**
   * Translate a single text and update cache
   */
  private translateSingle(text: string): void {
    this.repo.postRequest('api/donvi/addorupdate_ngonngu', {
      Ten: text,
      Id: this.activeLanguage.value
    }).subscribe(response => {
      if (response) {
        this.translationCache.set(text.toLowerCase(), response);
      }
    });
  }
}
